<router-outlet></router-outlet>
<p-toast position="top-center" key="global"></p-toast>
<tgcs-loader *ngIf="isLoading$ | async"></tgcs-loader>